import axios from 'axios';
import initPagination from "../module/pagination";

export default function ajaxSearchProducts() {


    initSearch();

    function initSearch() {
        const inputSearch = document.querySelector('#customSearch');
        const submitBtn = document.querySelector('.search__btn');
        const productCategory = document.querySelector('#productCategory');
        const productTypes = document.querySelectorAll('[data-type]');

        inputSearch?.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                executeSearch();
            }
        });

        submitBtn?.addEventListener('click', executeSearch);
        productCategory?.addEventListener('change', executeSearch);
        productTypes?.forEach(activeType);
    }

    function activeType(productType) {
        productType?.addEventListener('click', (e) => {
            e.preventDefault();
            const classActive = 'search-category__list-item--active';
            const type = productType.getAttribute('data-type');
            const activeElements = document.querySelectorAll(`.${classActive}`);
            const productTypeInput = document.querySelector('#productTypeInput');

            activeElements?.forEach(activeElement => activeElement.classList.remove(classActive));
            productType.classList.add(classActive);
            if(productTypeInput) {
                productTypeInput.value = type;
                executeSearch();
            }
        })
    }
    function executeSearch() {
        const productCategory = document.querySelector('#productCategory');
        const productTypeInput = document.querySelector('#productTypeInput');
        const inputSearch = document.querySelector('#customSearch');

        let searchTerm = inputSearch.value;
        let selectedCategory = productCategory?.value;
        let selectedType = productTypeInput?.value;

        let loadingGif = document.getElementById('loadingGif');
        if (loadingGif) {
            loadingGif.style.display = 'block';
        }

        let formData = new FormData();
        formData.append('action', 'custom_search_products');
        formData.append('term', searchTerm);
        formData.append('category', selectedCategory);
        formData.append('type', selectedType);

        axios.post('/wp-admin/admin-ajax.php', formData)
            .then(function (response) {
                const searchResult = document.querySelector('[data-search-result]');
                if (searchResult && response.data) {
                    searchResult.innerHTML = response.data;
                }
                const productCategory = document.querySelector('#productCategory');
                productCategory?.addEventListener('change', executeSearch);
                initSearch();
                initPagination();

                if (loadingGif) {
                    loadingGif.style.display = 'none';
                }
            })
            .catch(function (error) {
                console.error('Erreur Axios:', error);
                if (loadingGif) {
                    loadingGif.style.display = 'none';
                }
            });
    }

}

